import { type UseQueryResult, useQuery } from 'react-query';
import { TaxPeriodService } from '@wealthlane/api-services/wealthlane-tax-service';
import moment from 'moment';
import { DATE_FORMAT } from '../../constants/common';

const useGetTaxPeriodAllForApprover = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<any> => {
  const taxPeriodForApproverOptions = useQuery(
    ['getTaxPeriodAllForApprover'],
    async () => {
      return await handleRequest(TaxPeriodService.getApiTaxApiAppTaxPeriodTaxPeriodApprover());
    },
    {
      select: (data) => {
        const taxPeriod = data?.map((item: any) => {
          return {
            label:
              `${String(item?.name ?? '')}${' '} (${moment(item?.effectiveFrom).format(
                DATE_FORMAT
              )}-${moment(item?.effectiveTill).format(DATE_FORMAT)})` ?? '',
            value: item.id ?? '',
          };
        });

        return taxPeriod;
      },
    }
  );

  return taxPeriodForApproverOptions;
};

export default useGetTaxPeriodAllForApprover;
